module.exports = __webpack_public_path__ + "components/weather-icon/static/dayriskshowers-e61d0e6e35d6c7f3f6381840b2edff77.svg";